import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import {
    viewBuilder,
    changeBuilderStatus,
} from "../../Redux/Actions/builderActions";
import { ToFirstCapital } from "../../Utils/helpers";
import SearchBar from "../Main/searchBar";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import "./kioskView.css";


const ViewKiosk = () => {
    const { id } = useParams();
    const dispatch = useDispatch();

    const builderState = useSelector((state) => state.builders || {});
    console.log("builderState:", builderState);

    const [status, setStatus] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");
    const [showConfirm, setShowConfirm] = useState(false);
    const [isUpdating, setIsUpdating] = useState(false);

    const { admin } = useSelector((state) => state.admin || {});
    const accessCode = admin?.data?.access_code || [];
    const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
    const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

    useEffect(() => {
        if (id) dispatch(viewBuilder(id));
        else console.warn("No builder ID found in URL");
    }, [dispatch, id]);

    useEffect(() => {
        if (builderState.builder?.data?.account_status) {
            setStatus(builderState.builder.data.account_status);
        }
    }, [builderState.builder]);

    const data = builderState.builder?.data || {};

    const handleStatusChange = (e) => {
        setSelectedStatus(e.target.value);
        setShowConfirm(true);
    };

    const confirmStatusChange = () => {
        setIsUpdating(true);
        setShowConfirm(false);

        const builderId = data._id || data.id;

        if (builderId && selectedStatus) {
            const payload = {
                id: builderId,
                account_status: selectedStatus,
            };

            dispatch(changeBuilderStatus(payload)).finally(() =>
                setIsUpdating(false)
            );
        } else {
            setIsUpdating(false);
        }
    };

    const getStatusColor = (status) => {
        switch (status) {
            case "approved":
                return "#10b981";
            case "rejected":
                return "#ef4444";
            case "requested":
                return "#f59e0b";
            default:
                return "#6b7280";
        }
    };

    return (
        <div className="view-builder-container-new">
            <div className="searchbar-wrapper">
                <div className="searchbar-container">
                    <SearchBar />
                </div>
            </div>

            <div className="view-builder-header back-icon margin-0 gap-10 align-center flex-container">
                <Link to="/kiosk">
                    <BackIcon style={{ cursor: "pointer" }} />
                </Link>
                <div className="view-builder-title-section referral-view">
                    <h3 className="view-builder-main-title">Kiosk Provider Profile Details</h3>
                    <h4 className="view-builder-breadcrumb">Kiosk / List / View</h4>
                </div>
            </div>

            <div className={`builder-content-new ${isUpdating ? "opacity-60" : ""}`}>
                <div className="builder-profile-header">
                    <div className="builder-profile-main">
                        {data.profile_image ? (
                            <img
                                src={data.profile_image}
                                alt={data.brand_name}
                                className="builder-avatar"
                            />
                        ) : (
                            <div className="builder-avatar-placeholder">
                                {data.brand_name?.charAt(0) || "B"}
                            </div>
                        )}

                        <div className="builder-profile-info">
                            <h1 className="builder-name">{data.organization_name || "No Organization Name"}</h1>
                            <div className="builder-id-badge">Provider ID: {data.builder_id || "N/A"}</div>
                        </div>
                    </div>
                    c{canEdit &&
                        <div className="builder-status-control">
                            <label className="status-label" style={{ color: "white" }}>Account Status</label>
                            <select
                                value={status}
                                onChange={handleStatusChange}
                                className="status-select-new"
                                disabled={isUpdating}
                                style={{ borderColor: getStatusColor(status) }}
                            >
                                <option value="" disabled>Select Status</option>
                                {["requested", "approved", "rejected"].map((stat) => (
                                    <option key={stat} value={stat}>
                                        {ToFirstCapital(stat)}
                                    </option>
                                ))}
                            </select>
                        </div>
                    }
                </div>

                <div className="builder-details-grid">
                    <div className="builder-card">
                        <h3 className="card-title">Contact Information</h3>
                        <div className="card-content">
                            <div className="info-row">
                                <span className="info-label">Email</span>
                                <span className="info-value">{data.primary_email || "—"}</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">Phone</span>
                                <span className="info-value">
                                    {data.primary_contact_number
                                        ? `${data.primary_country_code} ${data.primary_contact_number}`
                                        : "—"}
                                </span>
                            </div>
                            {/* <div className="verification-badges">
                  <div className={`badge ${data.is_primary_email_verified ? "verified" : "unverified"}`}>
                    <span className="badge-icon">{data.is_primary_email_verified ? "✓" : "✕"}</span>
                    Email {data.is_primary_email_verified ? "Verified" : "Unverified"}
                  </div>
                  <div className={`badge ${data.is_primary_contact_number_verified ? "verified" : "unverified"}`}>
                    <span className="badge-icon">{data.is_primary_contact_number_verified ? "✓" : "✕"}</span>
                    Phone {data.is_primary_contact_number_verified ? "Verified" : "Unverified"}
                  </div>
                </div> */}
                        </div>
                    </div>

                    <div className="builder-card">
                        <h3 className="card-title">Location</h3>
                        <div className="card-content">
                            <div className="info-row">
                                <span className="info-label">Street Address</span>
                                <span className="info-value">{data.street_address || "—"}</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">City</span>
                                <span className="info-value">{data.city?.city_name || "—"}</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">State</span>
                                <span className="info-value">{data.state?.state_name || "—"}</span>
                            </div>
                            <div className="info-row">
                                <span className="info-label">Country</span>
                                <span className="info-value">{data.country?.country_name || "—"}</span>
                            </div>
                        </div>
                    </div>
                </div>
                {/* </div> */}
            </div>

            {showConfirm && (
                <div className="modal-overlay" onClick={() => setShowConfirm(false)}>
                    <div className="modal-box" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-header">
                            <h3>Confirm Status Change</h3>
                        </div>
                        <div className="modal-body">
                            <p>
                                Change account status to{" "}
                                <strong style={{ color: getStatusColor(selectedStatus) }}>
                                    {ToFirstCapital(selectedStatus)}
                                </strong>?
                            </p>
                        </div>
                        <div className="modal-footer">
                            <button
                                onClick={() => setShowConfirm(false)}
                                disabled={isUpdating}
                                className="btn-cancel"
                            >
                                Cancel
                            </button>
                            <button
                                onClick={confirmStatusChange}
                                disabled={isUpdating}
                                className="btn-confirm"
                            >
                                Confirm
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ViewKiosk;